import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "horizontal-2JmgP",
  "use": "horizontal-2JmgP-usage",
  "viewBox": "0 0 18 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 4\" id=\"horizontal-2JmgP\"><path fill-rule=\"evenodd\" d=\"M2 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol